<template>
  <div class="dialog" v-if="this.load">
    <!-- 详情弹窗 -->
    <div class="content">
      <div class="detail_pic">
        <div class="img">
          <img src="../../assets/left.png" class="smallImg" v-show="details.previou_id" @click="getDetails(details.previou_id)" />
          <div class="bigImg">
            <img :src="$img + select_image" />
            <!-- 收藏 -->
            <div @click="collect(details.is_collect)" class="collect">
              <i :class="[
                  details.is_collect === 1 ? 'is_collect' : 'no_collect',
                ]" class="el-icon-star-on"></i>
            </div>
          </div>
          <img src="../../assets/right.png" class="smallImg" v-show="details.next_id" @click="getDetails(details.next_id)" />
        </div>

        <!-- 其他图片 -->
        <div class="pic_list">
          <div class="mask">
            <div class="btn" @click="btnCilck(-4)"></div>
            <div class="btn" @click="btnCilck(-3)"></div>
            <div class="btn" @click="btnCilck(-2)"></div>
            <div class="btn" @click="btnCilck(-1)"></div>
            <div class="btn" @click="btnCilck(0)"></div>
            <div class="btn" @click="btnCilck(1)"></div>
            <div class="btn" @click="btnCilck(2)"></div>
            <div class="btn" @click="btnCilck(3)"></div>
            <div class="btn" @click="btnCilck(4)"></div>
          </div>
          <div class="list">
            <img :class="{ selectImg: index == selectIndex }" v-for="(item, index) in imageList" :key="index" :src="$img + item" />
          </div>
        </div>
      </div>
      <div class="detail_msg">
        <div class="left">
          <div class="title">
            <img src="../../assets/02.jpg" alt="" />{{ details.title }}
          </div>
          <div class="size">
            <span>大小：{{ details.desc.size }}</span>
            <span>格式：{{ details.desc.format }}</span>
          </div>
          <div class="popular">
            <!-- 下载量 -->
            <span>
              <img height="35" width="35" src="../../assets/hot.png" alt="" />
              <!-- <img
                v-else
                height="35"
                width="35"
                src="../../assets/hot-active.png"
                alt=""
              /> -->
              {{ details.down_no }}
            </span>
            <!-- 点赞量 -->
            <span>
              <img @click="resAssess(1)" height="35" width="35" v-show="details.like_status == 0 || details.like_status == -1" src="../../assets/suport.png" alt="" />
              <img @click="resAssess(0)" v-show="details.like_status == 1" height="35" width="35" src="../../assets/suport-active.png" alt="" />
              {{ details.like_no }}
            </span>
            <!-- 👎数量 -->
            <span>
              <img @click="resAssess(-1)" height="35" width="35" v-show="details.like_status == 0 || details.like_status == 1" src="../../assets/un_suport.png" alt="" />
              <img @click="resAssess(0)" height="35" width="35" v-show="details.like_status == -1" src="../../assets/un_suport-active.png" alt="" />
              {{ details.step_no }}
            </span>
          </div>
          <div class="other">
            <span>提示:数学产品不支持退货</span>
          </div>
          <div class="other">
            <span><i class="el-icon-warning-outline"></i>举报</span>
          </div>
        </div>
        <div class="right">
          <el-button v-if="!details.is_order" type="danger" @click="buySource">立即购买</el-button>
          <el-button v-else-if="!details.is_download" type="danger" @click="download">免费下载</el-button>
          <el-button v-else type="danger" @click="download">再次下载</el-button>
        </div>
      </div>
    </div>
    <!-- <div class="bottom">
      <div class="same">
        <div class="same_top">
          <span>相似文档</span>
          <span class="i" @click="resGetList"
            ><i class="el-icon-refresh-left"></i>换一换</span
          >
        </div>
        <div class="same_content">
          <div v-for="(item, index) in dataList" :key="index">
            <div class="same_list" @click="toDetail(item.product_id)">
              <img :src="$img + item.image" alt="" />
              <div>
                <div class="list_title">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import {
  getDetail,
  toggleCollect,
  buyResource,
  getList,
  assess
} from '../../api/index'
export default {
  name: 'imageDialog',
  data () {
    return {
      details: {},
      load: false,
      offset: 0,
      dataList: [],
      recommond_list: [],
      index: 0,
      select_image: '',
      imageList: [],
      firstIndex: 0, // 图片列表第一个图片下标
      selectIndex: 0 // 当前选择图片下标
    }
  },
  props: {
    product_id: Number
  },
  methods: {
    btnCilck (index) {
      console.log(this.imageList.length)
      if (
        this.firstIndex + index < 0 || this.firstIndex + index > this.imageList.length - 9
      ) {
        this.selectIndex = this.firstIndex + index + 4
        this.select_image = this.imageList[this.selectIndex]
        return
      }
      this.selectIndex = this.firstIndex + index + 4
      this.select_image = this.imageList[this.selectIndex]
      this.firstIndex += index
      document
        .querySelector('.pic_list')
        .style.setProperty('--margin', `${-this.firstIndex * 11.11}%`)
    },
    // 获取详情
    getDetails (id) {
      getDetail({ product_id: id }, (res) => {
        this.selectIndex = 0
        setTimeout(() => {
          document
            .querySelector('.pic_list')
            .style.setProperty('--margin', 0)
        }, 0)

        this.details = res.result.data
        this.details.desc = JSON.parse(res.result.data.desc)
        this.imageList = res.result.data.display_path
        this.select_image = this.imageList[0]
        this.load = true
      })
    },
    // 获取相似文档
    resGetList () {
      getList(
        {
          offset: this.offset,
          length: 3,
          type: 1,
          menus_id: 1
        },
        (res) => {
          this.dataList = res.result.data
          if (res.result.total > this.offset + 3) {
            this.offset += 3
          } else {
            this.offset = 0
          }
        }
      )
    },
    // 收藏
    collect (isCollect) {
      if (!this.$store.state.token) {
        this.$message.warning('请先登陆再进行操作')
        return
      }
      toggleCollect(
        {
          product_id: this.details.product_id,
          collect: isCollect ^ 1,
          token: this.$store.state.token
        },
        (res) => {
          if (res.status === 'success') {
            this.details.is_collect = this.details.is_collect ^ 1
          }
        }
      )
    },
    // 购买
    buySource () {
      if (!this.$store.state.token) {
        this.$message.warning('请先登陆再进行操作')
        return
      }
      buyResource(
        { product_id: this.details.product_id, token: this.$store.state.token },
        (res) => {
          if (res.status === 'success') {
            this.details.is_order = 1
          }
        }
      )
    },
    download () {
      this.$emit('download', this.details)
    },
    // 跳转详情页
    toDetail (id) {
      this.getDetails(id)
    },
    // 点赞
    resAssess (value) {
      assess({
        product_id: this.details.product_id,
        value: value
      }, res => {
        if (res.status == 'success') {
          this.details.like_status = res.result.data.data
          this.details.like_no = res.result.data.ass_no
          this.details.step_no = res.result.data.dept_no
        }
      })
    }
    // selectPic (index) {
    //   this.index = index
    // },
    // move_left () {
    //   if (this.index > 0) {
    //     this.index = this.index - 1
    //     this.imageList.unshift(this.imageList.pop())
    //     this.select_image = this.imageList[0]
    //   } else {
    //     this.index = 0
    //     // this.$message.warning('已经是第一张')
    //   }
    // },
    // move_right () {
    //   if (this.index < this.details.display_path.length) {
    //     this.index = this.index + 1
    //     this.imageList.push(this.imageList.shift())
    //     this.select_image = this.imageList[0]
    //   }
    // }
  },
  created () {
    this.getDetails(this.product_id)
    // this.resGetList()
  }
}
</script>

<style lang="scss" scoped>
.dialog {
  width: 100%;
  height: 100%;
  min-width: 864px;
  background-color: #ffffff;
  .content {
    width: 100%;
    // height: 100%;
    margin: 0 auto;
    padding: 10px;
    box-sizing: border-box;
    background-color: #ffffff;
    .detail_pic {
      position: relative;
      width: 100%;
      background-color: #fff;
      box-sizing: border-box;
      border-radius: 10px;
      .img {
        margin: 0 auto;
        padding: 30px 0 20px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        position: relative;
        img {
          margin: 0 auto;
          display: block;
          // width: 864px;
          height: 1200px;
        }
        .bigImg {
          position: relative;
        }
        .smallImg {
          width: 35px;
          height: 30px;
          padding: 20px;
          padding-right: 15px;
          border-radius: 50%;
          background-color: rgba(50, 50, 50, 0.4);
          cursor: pointer;
          position: absolute;
          top: 40%;
        }
        .smallImg:first-child {
          padding-left: 15px;
          padding-right: 20px;
          left: 30px;
        }
        .smallImg:last-child {
          right: 30px;
        }
      }

      .collect {
        z-index: 999;
        position: absolute;
        top: 10px;
        right: 10px;
        width: 50px;
        height: 50px;
        font-size: 38px;
        border-radius: 50%;
        box-shadow: 0 0 9px 3px #ccc;
        background-color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        .is_collect {
          color: #f4ea2a;
        }
        .no_collect {
          color: #999;
        }
      }
      .pic_list {
        padding: 20px 0;
        margin: 15px 0;
        box-sizing: border-box;
        --margin: -0%;
        width: 100%;
        height: 240px;
        overflow: hidden;
        position: relative;
        // background-color: rgba(50, 50, 50, 0.5);
        border-radius: 4px;
        .mask {
          width: 100%;
          height: 100%;
          position: absolute;
          .btn {
            width: 11.11%;
            height: 100%;
            opacity: 0;
            float: left;
          }
        }
        // .btn {
        //   height: 100%;
        //   width: 11.11%;
        //   opacity: 0;
        //   position: absolute;
        // }
        // .one {
        //   left: 20%;
        // }
        // .two {
        //   left: 40%;
        // }
        // .three {
        //   left: 60%;
        // }
        // .four {
        //   left: 80%;
        // }
        .list {
          margin-left: var(--margin);
          transition: margin 0.5s;
          width: 100%;
          height: 100%;
          display: flex;
          flex-wrap: nowrap;

          img {
            box-sizing: border-box;
            // display: inline-block;
            border: 1px solid rgba(0, 0, 0, 0);
            width: 11.11%;
            height: 100%;
            padding: 10px;
            transition: all 0.3s;
          }
          .selectImg {
            transform: scale(1.2);
            // border: 1px solid #0493fe;
            // margin: 0 15px;
            // box-shadow: 0 0 2px #cccccc;
            // z-index: 999;
            // border: 3px solid #ffffff;
          }
        }
      }
    }
    .detail_msg {
      margin-left: 20px;
      background-color: #fff;
      padding: 20px;
      display: flex;
      justify-content: space-between;
      .right {
        display: flex;
        align-items: center;
        .el-button {
          font-size: 20px;
          margin-right: 20px;
          margin-top: 40px;
          border-radius: 6px;
          height: 60px;
          width: 300px;
        }
      }
      .title {
        font-size: 24px;
        color: #333;
        display: flex;
        align-items: center;
        img {
          width: 60px;
          height: 60px;
          margin-right: 30px;
        }
      }
      .size {
        height: 40px;
        display: flex;
        align-items: center;
        margin: 10px 0;
        span {
          margin-right: 80px;
          font-size: 22px;
          color: #999999;
        }
      }
      .base {
        margin-top: 20px;
        font-size: 22px;
        color: #000;
      }
      .popular {
        display: flex;
        align-items: center;
        margin: 10px 0;
        font-size: 22px;
        color: #999;
        cursor: pointer;
        span {
          display: flex;
          align-items: center;
          margin-right: 60px;
          img {
            margin-right: 8px;
          }
          font-size: 20px;
        }
      }
      .popular2 {
        margin: 10px 0;
        font-size: 18px;
        color: #999;
      }
      .is_collect {
        color: red;
      }
      .no_collect {
        color: #999;
      }
      .character {
        margin-bottom: 20px;
        font-size: 12px;
        color: #666;
        span {
          margin: 0 5px;
        }
      }
      .other {
        margin: 15px 0;
        span {
          color: #999999;
          font-size: 18px;
          :first-child {
            margin-right: 5px;
          }
        }
      }
      .dialog-footer {
        display: flex;
        justify-content: space-between;
      }
    }
  }

  .bottom {
    width: 80%;
    margin: 0 auto;
    background-color: #ffffff;
    .same {
      background-color: #fff;
      border-radius: 10px;
      padding: 30px;
      margin-top: 20px;

      .same_top {
        display: flex;
        justify-content: space-between;
        color: #999;
        font-size: 16px;
        border-bottom: 1px solid #ccc;
        padding-bottom: 20px;
        .i {
          cursor: pointer;
        }
      }
      .same_content {
        display: flex;
        :last-child {
          margin-right: 0;
        }
        .same_list {
          margin-top: 20px;
          cursor: pointer;
          box-shadow: 0 0 8px #eeeeee;
          img {
            width: 100%;
            height: 360px;
          }
          & > div {
            padding: 10px;
            .list_title {
              font-size: 16px;
              color: #666;
            }
            .list_introduce {
              margin-top: 5px;
              margin-bottom: 10px;
              font-size: 16px;
              color: #999;
            }
          }
        }
      }
      .same_content > div {
        width: 32%;
        margin-right: 2%;
      }
    }
  }
}
</style>
<style lang="scss">
.detail_pic .el-carousel .el-carousel__container {
  height: 510px;
}
.detail_pic .el-carousel .el-carousel__container .el-carousel__arrow {
  width: 50px;
  height: 50px;
}
.detail_pic
  .el-carousel
  .el-carousel__container
  .el-carousel__arrow
  .el-icon-arrow-left {
  font-size: 24px;
}
.detail_pic
  .el-carousel
  .el-carousel__container
  .el-carousel__arrow
  .el-icon-arrow-right {
  font-size: 24px;
}
</style>
